// extracted by mini-css-extract-plugin
export var chip = "_fg-0";
export var filterDropdown = "_fg-5";
export var filterItem = "_fg-6";
export var icon = "_fg-1";
export var removeButton = "_fg-3";
export var removeIcon = "_fg-4";
export var separator = "_fg-2";